import React, { useState } from "react";
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import useStyle from "./style";
import hari1 from "../../../assets/images/checkin/hari1.png";
import hariBlank from "../../../assets/images/checkin/daily.png";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

function DialogCheckIn({ open, handleClose, data }) {
  const classes = useStyle();
  const { inpoinActivity, inpoinRef } = useData();
  const [loading, setLoading] = useState(false);
  const dateNow = new Date();
  const handleCheckIn = async () => {
    setLoading(true);
    const runActivity = firefunctions.httpsCallable("inpoin-runActivity");
    try {
      await runActivity({ alias: "CHECKIN" });
      // 1 is monday because monday sistem reset
      if (!inpoinActivity?.checkin) {
        let check = [
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          "isian",
          "isian",
        ];
        check[dateNow.getDay()] = true;
        inpoinRef?.set(
          {
            checkin: check,
          },
          { merge: true }
        );
      } else {
        let data = inpoinActivity?.checkin;
        data[dateNow.getDay()] = true;
        await inpoinRef?.set(
          {
            checkin: data,
          },
          { merge: true }
        );
      }
      setLoading(false);
      handleClose();
    } catch (error) {
      console.log(error.message);
      setLoading(false);
      handleClose();
    }
  };

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={handleClose}
      className={classes.dialog}
    >
      <DialogContent className={classes.dialogContent}>
        <div className={classes.wrapDialog}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {inpoinActivity?.checkin?.length > 0 ? (
              <div
                style={{
                  marginTop: "60px",
                  position: "absolute",
                  zIndex: 0,
                  marginRight: "20px",
                }}
              >
                <div className={classes.wrapHari}>
                  {inpoinActivity?.checkin?.slice(0, 3).map((item, index) => (
                    <div
                      className={classes.hari}
                      style={{
                        backgroundColor: item ? "#F93D92" : "#DCDCDC",
                        color: item ? "#fff" : "#767676",
                      }}
                    >
                      Hari {index + 1}
                    </div>
                  ))}
                </div>
                <div className={classes.wrapHari}>
                  {inpoinActivity?.checkin?.slice(3, 6).map((item, index) => (
                    <div
                      className={classes.hari}
                      style={{
                        backgroundColor: item ? "#F93D92" : "#DCDCDC",
                        color: item ? "#fff" : "#767676",
                      }}
                    >
                      Hari {index + 4}
                    </div>
                  ))}
                </div>
                <div className={classes.wrapHari}>
                  {inpoinActivity?.checkin?.slice(6, 9).map((item, index) => (
                    <div
                      className={classes.hari}
                      style={{
                        backgroundColor:
                          item && item !== "isian"
                            ? "#F93D92"
                            : item === "isian"
                            ? "#DCDCDC"
                            : "#DCDCDC",
                        color:
                          item && item !== "isian"
                            ? "#fff"
                            : item === "isian"
                            ? "#767676"
                            : "#767676",
                      }}
                    >
                      Hari {index + 7}
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
            <div
              style={{
                backgroundImage: inpoinActivity?.checkin?.length > 0 ? `url(${hari1})` : `url(${hariBlank})`,
                width: "100%",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "top",
                height: "250px",
                zIndex: 99,
              }}
            ></div>
          </div>

          <div className={classes.wrapContent}>
            <div
              style={{
                paddingTop: 10,
                paddingBottom: 10,
              }}
            >
              <div style={{ textAlign: "center", padding:"10px" }}>
                <Typography style={{ fontSize: "13px" }}>
                  {inpoinActivity?.checkin?.[dateNow.getDay()]
                    ? "Terimakasih telah melakukan check-in, 5 Coin telah dikirim ke akun kamu. silahkan cek di Tokorame Coin"
                    : "Ayok buruan check-in sekarang agar kamu mendapatkan 5 Coin dari Tokorame Coin"}
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <DialogActions style={{paddingBottom:10}}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            fullWidth
            disabled={loading}
            onClick={
              inpoinActivity?.checkin?.[dateNow.getDay()]
                ? handleClose
                : handleCheckIn
            }
          >
            {loading ? (
              <CircularProgress size={20} />
            ) : inpoinActivity?.checkin?.[dateNow.getDay()] ? (
              "Tutup"
            ) : (
              "Check in sekarang"
            )}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}

export default DialogCheckIn;
